/**
 * Texte du compteur de crédits (pied du tiroir Edgy et page Lite).
 * Extrait pour que les deux affichages ne divergent jamais.
 */
type CreditFields = { allowance: number; used: number; hasCredit: boolean; discoveryUsed: boolean };

export type EdgyCreditsLabels = { remaining: string; discovery: string; none: string };

export function remainingEdgyCredits(credits: Pick<CreditFields, "allowance" | "used"> | null | undefined): number {
  return credits ? Math.max(0, credits.allowance - credits.used) : 0;
}

export function edgyCreditsLabel(
  credits: CreditFields | null | undefined,
  labels: EdgyCreditsLabels,
): string {
  const remaining = remainingEdgyCredits(credits);
  if (credits && !credits.hasCredit) return labels.none;
  if (credits && remaining === 0 && !credits.discoveryUsed) return labels.discovery;
  return labels.remaining.replace("{remaining}", String(remaining));
}
